import colors from './colors';

const darkTheme = {
    color: colors
};

export default darkTheme;
